import { inject, observer } from "mobx-react";
import React from "react";

import { UserStatus } from "../../models/NewExistingOwner";
import Store from "../../stores/NewExistingOwnerStore";

interface IProps {
  active?: number;
  store?: Store;
}
interface IState {}

const steps: string[] = ["My car", "My details"];

@inject("store")
@observer
class OwnerNav extends React.Component<IProps, IState> {
  state: IState = {};

  get store(): Store {
    return this.props.store;
  }

  render() {
    const active: number = this.props.active || 0;

    return (
      <div className="step-nav-wrapper">
        <ul className="step-nav">
          {steps.map((step: string, i: number) => {
            const classNames: string[] = [];

            if (i < active) classNames.push("is-completed");
            if (i === active) {
              classNames.push("is-active");
              const { userStatus } = this.store;
              const _stage = userStatus === UserStatus.New ? "register your Subaru" : "update your details";
              window['pushDigitalData']({
                  "event": "_formNavigate",
                  "form": {
                      "name": _stage,
                      "stage": step
                  },
              }, true);
            }

            return (
              <li className={classNames.join(" ")} key={`nav-${i}`}>
                <span>{step}</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default OwnerNav;
